import EFPicture from '@elem/ui/ef-picture';
import EfSection from '@elem/ui/ef-section';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('power_kits_48v_system');
    const lists = [
        {
            app: t('F_app1'),
            num: t('F_app1_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721122969663/refrigerator.svg',
        },
        {
            app: t('F_app2'),
            num: t('F_app2_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123005541/coffee_machine.svg',
        },
        {
            app: t('F_app3'),
            num: t('F_app3_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123044688/electric_grill.svg',
            hide: true,
        },
        {
            app: t('F_app4'),
            num: t('F_app4_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123068132/frying_pan.svg',
            hide: true,
        },
        {
            app: t('F_app5'),
            num: t('F_app5_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123105353/microwave.svg',
        },
        {
            app: t('F_app6'),
            num: t('F_app6_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123133348/electric_oven.svg',
            hide: true,
        },
        {
            app: t('F_app7'),
            num: t('F_app7_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123153411/induction_cooker.svg',
        },
        {
            app: t('F_app8'),
            num: t('F_app8_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123165099/kettle.svg',
            hide: true,
        },
        {
            app: t('F_app9'),
            num: t('F_app9_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123186204/hair_dryer.svg',
            hide: true,
        },
        {
            app: t('F_app10'),
            num: t('F_app10_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123193936/heater.svg',
        },
        {
            app: t('F_app11'),
            num: t('F_app11_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123218544/air_condition.svg',
        },
        {
            app: t('F_app12'),
            num: t('F_app12_n'),
            icon: 'https://websiteoss.ecoflow.com/upload/image/1721123226321/electric_hammer.svg',
            hide: true,
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSection
                position="hover"
                theme="white"
                pc="https://websiteoss.ecoflow.com/upload/image/1723102022794/pc_off%20grid.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1723102022794/pc_off%20grid.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1723102077325/m_off%20grid.jpg"
                label={t('F_label')}
                title={t('F_title')}
                desc={t('F_desc')}
            />
            <ul className="icons">
                {lists?.map((list: any, k: number) => (
                    <li className={`icon ${list?.hide ? 'hide' : ''}`} key={k}>
                        <div className="icon-svg">
                            <EFPicture src={list.icon} alt={list.app} />
                        </div>
                        <p className="icon-app">{list.app}</p>
                        <p className="icon-num">
                            <span className="num-text">{list.num}</span>
                            <span className="num-unit">{t('F_n_unit')}</span>
                        </p>
                    </li>
                ))}
            </ul>
        </div>
    );
}
